import * as React from "react";
import "../Styles/style.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Confirm from "../../images/blue-tick-success.png";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

const FeatureAdPostBody = ({ open, onClose, categoryName, typeName }) => {
  const history = useHistory();

  const [showPackages, setShowPackages] = React.useState(false);
  const [packageIndex, setPackageIndex] = React.useState(0);
  const [carPackage, setCarPackage] = React.useState(null);
  const [price, setPrice] = React.useState(0);

  const handleGotoAd = () => {
    history.push("pending-ads");
  };

  return (
    <>
      <Modal open={open} onClose={() => onClose()} disableAutoFocus={true}>
        <Box className="successModal w-50" sx={successModal}>
          <div className="text-center">
            <h3>Success!</h3>
            <h5>Your Ad Posted successfully.</h5>
            {typeName === "Sell to fameWheels" && <p>Redirecting ....</p>}

            <button
              className="rounded border-0 px-2 py-1 contactSellerBtn color-white"
              onClick={handleGotoAd}
            >
              <i className="fa-sharp fa-solid fa-eye me-1"></i> View Your Ad{" "}
            </button>
          </div>
          {typeName === "Free Ads" && (
            <>
              <h5 className="mt-3 text-black fw-600 text-center">
                Want to Sell Your Car Faster?
              </h5>

              <div className="row d-flex justify-content-center align-items-center mt-3">
                <div className="col-lg-2">
                  <img
                    src="https://wsa3.pakwheels.com/assets/get-featured-car-e4cd11ec4696af67a5d5c4b4288fec64.svg"
                    alt="feature-img"
                  />
                </div>

                <div className="col-lg-6">
                  <div className="d-flex gap-3 align-items-center">
                    <i className="fa-solid fa-check text-success"></i>
                    <span className="fontSm">
                      Reach up to 10x times more buyers
                    </span>
                  </div>

                  <div className="d-flex gap-3 align-items-center my-2">
                    <i className="fa-solid fa-check text-success"></i>
                    <span className="fontSm">Show your Ad in top position</span>
                  </div>

                  <div className="d-flex gap-3 align-items-center">
                    <i className="fa-solid fa-check text-success"></i>
                    <span className="fontSm">
                      Get noticed with a Feature Ad tag
                    </span>
                  </div>
                </div>
              </div>

              {showPackages ? (
                <>
                  <h5 className="fs-5 my-3 fw-600 text-black">
                    Buy Multiple Ad Packages here
                  </h5>

                  <label
                    id="5Car"
                    className={`d-flex justify-content-between p-3 rounded ${
                      packageIndex === 1
                        ? "bgLightRed border border-danger"
                        : "border border-black-50"
                    } my-2`}
                    onClick={() => {
                      setCarPackage({ name: "5 Cars pack", price: 9500 });
                      setPackageIndex(1);
                    }}
                  >
                    <div className="d-flex gap-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="5Car"
                        name="car"
                      />
                      <div>
                        <div className="d-flex gap-3 m-0 p-0">
                          <h5 className="text-black fs-5">5 Car Pack</h5>
                        </div>
                        <p className="text-black-50 fontSm m-0 p-0">
                          Recommended for small sized businesses
                        </p>
                      </div>
                    </div>
                    <p className="text-black fw-600">PKR 9,500</p>
                  </label>

                  <label
                    id="10Car"
                    className={`d-flex justify-content-between p-3 rounded ${
                      packageIndex === 2
                        ? "bgLightRed border border-danger"
                        : "border border-black-50"
                    } my-2`}
                    onClick={() => {
                      setCarPackage({ name: "10 Cars pack", price: 18500 });
                      setPackageIndex(2);
                    }}
                  >
                    <div className="d-flex gap-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="10Car"
                        name="car"
                      />
                      <div>
                        <div className="d-flex gap-3 m-0 p-0">
                          <h5 className="text-black fs-5">10 Car Pack</h5>
                        </div>
                        <p className="text-black-50 fontSm m-0 p-0">
                          Recommended for medium sized businesses
                        </p>
                      </div>
                    </div>
                    <p className="text-black fw-600">PKR 18,500</p>
                  </label>

                  <label
                    id="20Car"
                    className={`d-flex justify-content-between p-3 rounded ${
                      packageIndex === 3
                        ? "bgLightRed border border-danger"
                        : "border border-black-50"
                    } my-2`}
                    onClick={() => {
                      setCarPackage({ name: "20 Cars pack", price: 36000 });
                      setPackageIndex(3);
                    }}
                  >
                    <div className="d-flex gap-3">
                      <input
                        id="20Car"
                        name="car"
                        type="radio"
                        className="form-check-input"
                      />
                      <div>
                        <div className="d-flex gap-3 m-0 p-0">
                          <h5 className="text-black fs-5">20 Car Pack</h5>
                        </div>
                        <p className="text-black-50 fontSm m-0 p-0">
                          Recommended for large sized businesses
                        </p>
                      </div>
                    </div>
                    <p className="text-black fw-600">PKR 36,000</p>
                  </label>

                  <p
                    className="text-black mt-2 text-center"
                    style={{ fontSize: "12px" }}
                  >
                    Private Seller ?{" "}
                    <button
                      className="btn text-primary p-0"
                      style={{ fontSize: "12px" }}
                      onClick={() => setShowPackages(false)}
                    >
                      Go back to Feature Ad option
                    </button>
                  </p>
                </>
              ) : (
                <>
                  {categoryName <= 1000 && (
                    <label
                      id="singleCar"
                      className={`w-100 ${
                        packageIndex === 0
                          ? "bgLightRed border border-danger"
                          : "border border-black-50"
                      } p-3 rounded mt-3 `}
                      onClick={() => {
                        setPackageIndex(0);
                        setPrice(500);
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <div className="mb-3">
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="singleCar"
                              name="car"
                              checked={packageIndex === 0 ? true : false}
                            />

                            <div className="d-flex gap-3">
                              <h5 className="text-black fs-5">7 Days</h5>
                              {categoryName <= 1000 && (
                                <p className="contactSellerBtn text-white py-1 px-2 rounded">
                                  Recommended
                                </p>
                              )}
                            </div>
                          </div>
                          <p className="text-black-50 fontSm m-0 p-0">
                            Recommended for luxury and sports cars
                          </p>
                        </div>

                        <p className="text-black fw-600">PKR 500</p>
                      </div>
                    </label>
                  )}

                  {categoryName <= 2000 && (
                    <label
                      id="singleCar"
                      className={`w-100 ${
                        packageIndex === 4
                          ? "bgLightRed border border-danger"
                          : "border border-black-50"
                      } p-3 rounded mt-3 `}
                      onClick={() => {
                        setPackageIndex(4);
                        setPrice(1000);
                      }}
                    >
                      <div className="d-flex justify-content-between">
                        <div className="mb-3">
                          <div className="d-flex gap-3">
                            <input
                              type="radio"
                              className="form-check-input"
                              id="singleCar"
                              name="car"
                              checked={packageIndex === 4 ? true : false}
                            />

                            <div className="d-flex gap-3">
                              <h5 className="text-black fs-5">14 Days</h5>
                              {categoryName <= 2000 && categoryName > 1000 && (
                                <p className="contactSellerBtn text-white py-1 px-2 rounded">
                                  Recommended
                                </p>
                              )}
                            </div>
                          </div>
                          <p className="text-black-50 fontSm m-0 p-0">
                            Recommended for luxury and sports cars
                          </p>
                        </div>

                        <p className="text-black fw-600">PKR 1000</p>
                      </div>
                    </label>
                  )}

                  <label
                    id="singleCar"
                    className={`w-100 ${
                      packageIndex === 5
                        ? "bgLightRed border border-danger"
                        : "border border-black-50"
                    } p-3 rounded mt-3 `}
                    onClick={() => {
                      setPackageIndex(5);
                      setPrice(1500);
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="mb-3">
                        <div className="d-flex gap-3">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="singleCar"
                            name="car"
                            checked={packageIndex === 5 ? true : false}
                          />

                          <div className="d-flex gap-3">
                            <h5 className="text-black fs-5">28 Days</h5>
                            {categoryName > 2000 && (
                              <p className="contactSellerBtn text-white py-1 px-2 rounded">
                                Recommended
                              </p>
                            )}
                          </div>
                        </div>
                        <p className="text-black-50 fontSm m-0 p-0">
                          Recommended for luxury and sports cars
                        </p>
                      </div>

                      <p className="text-black fw-600">PKR 1500</p>
                    </div>
                  </label>
                </>
              )}

              <div className="d-flex justify-content-center mt-3">
                <Button variant="contained" className="bgSecondary">
                  Proceed To Checkout
                </Button>
              </div>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default FeatureAdPostBody;
